<template>
  <div class="tab_action tab_bg">
    <loading
      :width="100"
      loader="dots"
      color="#ffacb7"
      :active="actionLoading"
      background-color="transparent"
    />
    <div class="backtop">
      <span class="btncenter">音频管理</span>
    </div>
    <div class="tab" style="position: unset; overflow-y: auto">
      <ul>
        <li @click="checkTab(4)" :class="{ check: Tab == 4 }">音效</li>
        <li @click="checkTab(5)" :class="{ check: Tab == 5 }">配乐</li>
      </ul>

      <div class="liebiao">
        <div>
          <span @click="checkSourceTab(2)" :class="{ active: sourceTab == 2 }"
            >平台</span
          >
          <span @click="checkSourceTab(1)" :class="{ active: sourceTab == 1 }"
            >个人</span
          >
        </div>
        <div v-if="Tab == 4">
          <select v-model="getAudioList.materialType" @change="getList()">
            <option
              :label="item.label"
              :value="item.materialType"
              v-for="(item, i) in categroy4"
              :key="i + 'shaixuan'"
            ></option>
          </select>
        </div>
        <div v-else-if="Tab == 5">
          <select v-model="getAudioList.materialType" @change="getList()">
            <option
              :label="item.label"
              :value="item.materialType"
              v-for="(item, i) in categroy5"
              :key="i + 'shaixuan'"
            ></option>
          </select>
        </div>
      </div>

      <div class="content-box" style="height: unset; margin-bottom: 50px">
        <div v-if="!showPanelUp">
          <!-- <button @click="showPanelUp = true">上传图片</button> -->
          <ul
            class="tab_ul"
            style="height: calc(100% - 170px); padding-bottom: 0"
          >
            <li
              v-if="sourceTab == 1 && Pagination.pageIndex == 1"
              class="tab_column"
              @click="addUp()"
            >
              +
            </li>

            <li
              v-for="(item, index) in audioList"
              :key="index + 'i'"
              @click.self="selectorAudio(item)"
            >
              <span
                @click="play(item)"
                v-if="item.materialId === music.materialId"
                class="icon iconfont icon-weibiaoti519"
              ></span>
              <span
                @click="play(item)"
                v-else
                class="icon iconfont icon-weibiaoti518"
              ></span>
              <div class="tab_div">{{ item.materialName }}</div>
              <div class="tab_edit" v-if="sourceTab == 1">
                <div @click.stop="editSource(item)"><span>编辑</span></div>
                <div @click.stop="delSource(item.materialId)">
                  <span>删除</span>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <div
          v-if="showPanelUp"
          class="add-box addform_box"
          style="bottom: -200px"
        >
          <div class="add-content">
            <div class="setup_title"><i></i>音频上传</div>
            <div class="setup_cancel" @click="showPanelUp = false">返回</div>
            <div class="setup_content">
              <div class="setup_box">
                <div class="setup_lable">音频名称：</div>
                <div class="setup_block">
                  <input
                    type="text"
                    v-model="addForm.materialName"
                    value=""
                    placeholder="请输入素材名称"
                  />
                </div>
              </div>
              <div class="setup_box">
                <div class="setup_lable">音频类型：</div>
                <div class="setup_block">
                  <select v-model="addForm.materialType">
                    <option
                      :label="item.label"
                      :value="item.materialType"
                      v-for="(item, i) in Tab === 4 ? categroy4 : categroy5"
                      :key="i"
                    ></option>
                  </select>
                </div>
              </div>
              <div class="setup_box fengmian">
                <div class="setup_lable">音频文件：</div>
                <div class="setup_block" style="position: relative">
                  <div
                    class="uploader"
                    v-if="
                      addForm.materialPath == null ||
                      addForm.materialPath.length <= 0
                    "
                  >
                    +
                  </div>
                  <div
                    v-if="
                      addForm.materialPath != null &&
                      addForm.materialPath.length > 0
                    "
                    class="uploader_img uploader_audio"
                  >
                    <div
                      class="name"
                      ref="songName1"
                      v-html="addForm.materialName"
                      :class="{ scroll: nameScroll }"
                    ></div>
                  </div>
                  <div class="defaultupload" @click="opUpFile('audio')">
                    <fileUpload
                      ref="upAudio"
                      v-show="false"
                      id="Audioupload"
                      accept="*"
                      typefolder="audio"
                      parentfolder="material"
                      @progress="uploadProgress"
                      @checkfile="checkfile"
                      @error="uploadError"
                      @success="uploadSuccessAudio"
                    ></fileUpload>
                  </div>
                </div>
              </div>
              <!-- <div class="setup_box">
                注意：背景支持图片(jpg、png)与视频(mp4、mov、ogg)
              </div> -->
              <div v-if="uppro > 0 && uppro < 100">上传中 {{ uppro }}%</div>
            </div>
          </div>

          <div class="savebtn">
            <span @click="saveMaterial" class="confirmbtn">保存素材</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 分页组件 -->
    <pagination
      v-if="audioList.length > 0 && !showPanelUp"
      class="pull-right-dis"
      :paginationOpt="Pagination"
      @switchPage="employeePagesFn"
      style="
        bottom: 30px;
        padding: 0;
        position: absolute;
        right: 0;
        box-shadow: none;
      "
    />
    <!-- // 播放器组件 -->
    <aplayer
      style="left: 0px; bottom: 100px"
      v-if="music.materialId"
      autoplay
      :float="true"
      ref="aplayer"
      @pause="pause"
      :music="music"
    />
  </div>
</template>
<script>
import pagination from '@/components/pagination/index.vue'

import fileUpload from '@/components/ali_oss/alioss.vue'
import { repUrl, getVideo, beforeAvatarUpload } from '@/components/util/util_fun.js'
import { t9oss } from '@/components/util/util.js'
// ES6
import Aplayer from 'vue-aplayer'


export default {
  components: {
    fileUpload,
    pagination,
    Aplayer
  },
  name: 'AudioSelector',
  data () {
    return {
      defaultImg: require('@/assets/images/defalut.png'),
      uppro: 0,// 文件上传进度
      Pagination: {
        //分页
        pageIndex: 1,
        pageSize: 20,
        totalCount: 1,
        pageCount: 0
      },
      sourceTab: 2,//平台||个人场景
      audioList: [],
      addForm: {
        "materialName": '',
        "materialPath": '',
        "materialType": '4',// 
        "materialSource": 1,//1.个人上传 2.平台素材
        "materialSize": 0,
        "materialJson": '',
      },
      getAudioList: {
        "searchText": "",
        "pageIndex": 0,
        "pageSize": 24,
        "sort": 1,//	排序 1.正序 2.倒序
        "materialType": '4',// 4 音效 5 配乐
        "materialSource": 2,//素材来源 0.默认不筛选 1.个人上传 2.平台素材	
      },
      categroy4: [{
        "label": "全部分类",
        "materialType": "4",
        "children": []
      }],
      categroy5: [{
        "label": "全部分类",
        "materialType": "5",
        "children": []
      }],
      showPanelUp: false,//上传音频文件
      Tab: 4,
      music: {},
      nameScroll: false,
      actionLoading: false,// 保存素材按钮loading
    }
  },
  created () {
    // 获取下拉筛选参数
    this.get('/vup/static/config/material.json').then((res) => {

      var guajian = res.data[3].children
      for (let a = 0; a < guajian.length; a++) {
        this.categroy4.push(guajian[a])
      }
      var guajian4 = res.data[4].children
      for (let a = 0; a < guajian4.length; a++) {
        this.categroy5.push(guajian4[a])
      }
    })
  },
  destroyed () {
    // console.log('销毁');;
  },
  mounted () {
    this.getList()
  },
  methods: {
    play (item) {
      if (this.music.materialId) {
        // console.log('在播放', this.music.materialId)
        if (this.music.materialId != item.materialId) {
          this.music = {
            title: item.materialName,
            artist: '试听音频',
            src: item.materialPath,
            pic: '',
            materialId: item.materialId
          }
          this.$nextTick(() => {
            this.$refs.aplayer.play()
          })
        } else {
          console.log(this.music.materialId)
          console.log(item.materialId)
          this.music = {}
          this.$refs.aplayer.pause()
        }
      } else {
        // console.log('播放的文件', item)
        this.music = {
          title: item.materialName,
          artist: '试听音频',
          src: item.materialPath,
          pic: '',
          materialId: item.materialId
        }
      }


    },
    pause (e) {
      console.log('监听暂停', e)
    },
    getList (cb) { //获取列表
      this.actionLoading = true

      if (this.getAudioList.pageIndex == 0) { // 如果是第一页，则需要减一,因为上传按钮占一个<li/>
        this.getAudioList.pageSize = this.getAudioList.pageSize - 1
      }
      if (this.getAudioList.materialSource == 2) {
        this.getAudioList.pageSize = 24   // 如果是平台素材，正常显示
      }

      this.post("/material/findMaterialList", this.getAudioList).then((res) => {
        console.log('获取音频文件', res)
        if (res.status == "200") {
          this.getAudioList.pageSize = 24 // 恢复正常请求一页页数
          this.audioList = res.data[0]
          this.Pagination.totalCount = res.data[1]
          this.Pagination.pageCount = Math.ceil(this.Pagination.totalCount / this.Pagination.pageSize)


          this.actionLoading = false
        }
      }).catch(() => {
        this.actionLoading = false
      })
      !!cb && cb()//分页用到了
    },

    opUpFile () { // 上传音频文件
      this.$refs.upAudio.$el.click()

    },


    // 分页
    employeePagesFn (pageIndex, cb) { //pageIndex --- 分页组件返回的页码，    cb ---- 主要目的是为分页加锁，固定参数
      let self = this

      self.Pagination.pageIndex = pageIndex
      self.getAudioList.pageIndex = pageIndex - 1

      self.getList(cb)
    },
    // 切换4音效或者5配乐 
    checkTab (type) {
      // console.log('this.backList清空', this.backList)
      this.music = {}
      this.audioList = []

      this.showPanelUp = false
      this.getAudioList.pageIndex = 0
      this.Pagination.pageIndex = 1
      this.getAudioList.materialType = type
      this.Tab = type
      this.getList()
    },
    // 切换平台或个人
    checkSourceTab (type) {
      this.music = {}
      this.audioList = []
      this.showPanelUp = false
      this.getAudioList.pageIndex = 0
      this.Pagination.pageIndex = 1
      this.sourceTab = type
      this.getAudioList.materialSource = type
      this.getList()
    },
    // 编辑素材
    editSource (source) {
      console.log('点击编辑的回调', source)
      this.addForm = source
      this.showPanelUp = true
    },
    // 删除素材
    delSource (code) {
      // console.log('点击删除的回调', code)
      this.$confirm({
        title: "操作提示",
        type: "warning",
        message: '此操作将永久删除该素材, 是否继续?'
      }).then(() => {

        this.post("/material/deleteMaterial", { code: code }).then((res) => {

          if (res.status == "200") {
            this.audioList.find((t, index) => {

              if (t.materialId == code) {

                this.audioList.splice(index, 1)
              }
            })
            this.$message.success("删除成功")

          } else {
            this.$message.error("删除失败")
          }
        })
          .catch((fail) => {

          })

      })
    },
    addUp () {
      this.showPanelUp = true
      this.addForm = {
        "materialName": '',
        "materialPath": '',
        "materialType": this.getAudioList.materialType,
        "materialSource": 1,//1.个人上传 2.平台素材
        "materialSize": 0,
        "materialJson": '', // 放置 封面图片
      },
        console.log('上传show')
    },
    saveMaterial () { //保存素材
      // console.log('保存素材', this.addForm)

      if (this.addForm.materialPath == '') return this.$message.error("文件不能为空")
      if (this.addForm.materialName.length > 20 || this.addForm.materialName.lenght == 0) return this.$message.error("素材名称不能为空,且不能超过20字符")
      if (this.addForm.materialId) {
        console.log('进入编辑')
        this.post("/material/editMaterial", this.addForm).then((res) => {
          try {
            if (res.status == "200") {
              this.$message.success('修改成功')

            } else if (res.status == "21") {

              this.$message.error(res.message)
            } else {

              this.$message.error('修改失败')
            }
            this.showPanelUp = false
            this.getList()
          } catch (error) {
            console.log('捕获错误')
            console.dir(error)

          }

        })
      } else {
        this.post("/material/saveMaterial", this.addForm).then((res) => {
          // console.log('保存素材回调', res)
          if (res.status == 200) {

            // this.audioList.push(res.data)
            this.getList()
            this.$message.success("添加成功")
            // console.log(this.audioList)
            this.showPanelUp = false
          }
        })
      }

    },
    // ---------------上传回调-------------------------------------------
    //上传成功音频！
    uploadSuccessAudio (json) {
      console.log('上传成功的json', json)
      if (json.fileDir.length <= 0) {
        this.$message.error("上传文件不可用!")
      } else {
        // 判断是否为对象,如果是字符串,则转换为对象
        if (json.fileName.length > 20) {
          // 截取前20个字符
          this.addForm.materialName = json.fileName.substring(0, 20)
        } else {
          this.addForm.materialName = json.fileName
        }
        this.addForm.materialPath = t9oss + '/' + repUrl(json.fileUrl)
        console.log('上传成功音频！当前的addform', this.addForm)
        this.$nextTick(() => {
          // console.log('refs', this.$refs.songName1, this.nameScroll)
          if (this.$refs.songName1.scrollWidth > 300) {
            this.$refs.songName1.style.width = this.$refs.songName1.scrollWidth + "px"
            this.nameScroll = true
          } else {
            this.nameScroll = false
          }
        })
        this.$message.success("上传成功")

      }

    },

    //上传失败
    uploadError (err) {
      //   this.uploadloading = false
      this.$message.error("上传失败！")
      console.error(err)
    },

    //文件选择成功
    async checkfile (file) {
      //   this.uploadloading = true
      console.log('file', file)

    },
    //进度条
    uploadProgress (progress) {
      console.log('进度', progress)
      this.uppro = parseInt(progress * 100)
    },
    selectorAudio (item) {
      console.log('选中的音频', item)
      this.$emit('selector', item)
    },

  }
}
</script>
<style lang="scss" scoped>
.tab_action .setup_action li {
  background: transparent;
  background-size: cover;
}
.tab_houzhui {
  background-color: #f95f8e;
  color: #fff;
  position: absolute;
  right: 0;
  top: 0;
  border-radius: 0 20px 0 20px;
  padding: 0 12px;
  font-size: 12px;
  line-height: 20px;
}
.setup_cancel {
  width: 60px;
  background-color: #eee;
  border-radius: 12px;
  /* margin: 0 auto; */
  text-align: center;
  cursor: pointer;
}
.liebiao {
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  select {
    height: 29px;
    padding: 0 5px;
    color: #666;
    border: 1px solid #dbdbdb;
  }
}
.liebiao span {
  display: inline-block;
  padding: 5px 10px;
  margin: 0 5px;
  background-color: #f7f8fa;
  border-radius: 2px;
  color: #666;
  cursor: pointer;
}
.liebiao .active {
  background-color: #f4acb7;
  color: #fff;
}
.tab_edit {
  border-radius: 0 0 20px 20px;
  height: 30px;
}
.content-box {
}
.tab_action .tab_ul li {
  margin-bottom: 50px;
  .icon{
    font-size: 44px;
    // line-height: 100px;
    position: absolute;
    left: 0;
    top: 0;
  }
}
.content-box > div {
  // padding-bottom: 100px;
}

@import "@/style/mixin.scss";
.uploader_audio {
  overflow: hidden;
  // white-space: nowrap;
  width: 300px;
  height: 50px;
  line-height: 50px;
}
.name {
  white-space: nowrap;
}
.name.scroll {
  animation: 3s wordsLoop linear infinite;
}
@keyframes wordsLoop {
  0% {
    transform: translateX(0px);
  }
  25% {
    transform: translateX(0px);
  }
  75% {
    transform: translateX(calc(-100% + 300px));
  }
  100% {
    transform: translateX(calc(-100% + 300px));
  }
}



</style>
